module.exports = __webpack_public_path__ + "static/media/headquarter.ccd07cd9.png";